import once from "lodash/once";

export const getAppVersion = once(function getAppVersion(): string {
  // NOTE: For some reason in tests `null` is `"null"`
  // `REACT_APP_ANYDO_VERSION` doesn't exist in Storybook
  if (process.env.STORYBOOK_STORYBOOK != null && process.env.STORYBOOK_STORYBOOK !== "null") {
    return "4.0.0-local";
  }

  const version = process.env.REACT_APP_ANYDO_VERSION;

  // We ensure REACT_APP_ANYDO_VERSION existence in local builds: `@anydo/anydo-scripts/src/utils/getClientEnvironment.js`
  if (version == null || version === "") {
    throw new Error("process.env.['REACT_APP_ANYDO_VERSION'] must be set");
  }

  return version;
});
